import apiClient from 'services/apiClient';

export const Chatbots = async (setLoading,api,id,authToken,setChatbots,GroupId = null) => {
    setLoading(true)
    try {
        const response = await apiClient.get(`${api}chatbot/${id}/${GroupId ? GroupId : null}`,
            {
                headers: {
                    'Authorization': 'Bearer ' + authToken,
                }
            });
        const data = response.data.chatbot;
        setChatbots(data);
        setLoading(false)
    } catch (error) {
        setLoading(false)
        console.log(error);
    }
}